import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT,
  CHANGE_PASSWORD
} from '../constants';

const initialState = {
  loading: false,
  userInfo: localStorage.getItem('userInfo')
    ? JSON.parse(localStorage.getItem('userInfo'))
    : null,
  error: null,
  changePassword:[]
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
      return { ...state, loading: true };
    case USER_LOGIN_SUCCESS:
      return { loading: false, userInfo: action.payload, error: null };
    case USER_LOGIN_FAIL:
      return { loading: false, error: action.payload, userInfo: null };
    case USER_LOGOUT:
      return { loading: false, userInfo: null, error: null };
        case CHANGE_PASSWORD: {
      return {
        ...state,
        changePassword: payload,
      };
    }
    default:
      return state;
  }
};
export default reducer;